const resolveApprovalRouteKey = (metadata = {}) => {
  if (metadata.approvalRoute) return metadata.approvalRoute;
  const { approvalType, approvalStage } = metadata;
  if (approvalType === 'supervisors') return 'teamSupervisors';
  if (approvalType === 'admin') return 'admin';
  if (approvalType === 'project') {
    return approvalStage === 2 ? 'projectApprover2' : 'projectApprover1';
  }
  if (approvalType === 'companywide') {
    return approvalStage === 2 ? 'companyApprover2' : 'companyApprover1';
  }
  return null;
};

export const getApprovalRouteLabel = (t, metadata = {}) => {
  const routeKey = resolveApprovalRouteKey(metadata);
  const projectLabel = t('Project').toLowerCase();
  switch (routeKey) {
    case 'projectApprover1':
      return `${projectLabel} first approver`;
    case 'projectApprover2':
      return `${projectLabel} second approver`;
    case 'companyApprover1':
      return 'company first approver';
    case 'companyApprover2':
      return 'company second approver';
    case 'teamSupervisors':
      return 'team supervisor';
    case 'admin':
      return 'admin approver';
    default:
      return null;
  }
};

export const formatLivePendingApproverNames = (
  livePendingApprovers = [],
  userMap = {},
  positionMap = {},
) => livePendingApprovers
  ?.map(({ userId, positionId }) => {
    if (userId && userMap[userId]?.name) return userMap[userId].name;
    if (positionId && positionMap[positionId]?.name) {
      return `Any ${positionMap[positionId].name}`;
    }
    return null;
  })
  .filter(Boolean) ?? [];

export const getApprovalRoutingTimelineText = ({
  metadata,
  livePendingApprovers,
  userMap,
  positionMap,
  t,
}) => {
  const routeLabel = getApprovalRouteLabel(t, metadata);
  if (!routeLabel) return null;

  const names = formatLivePendingApproverNames(
    livePendingApprovers,
    userMap,
    positionMap,
  );

  if (names.length) {
    return `Awaiting ${routeLabel}: ${names.join(', ')}`;
  }

  return `Sent to ${routeLabel}`;
};
